'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { startTransition } from 'react';
interface UseFastNavigationOptions {
  onBeforeNavigate?: () => void;
}
export const useFastNavigation = (href, options) => {
  const $ = _c(11);
  const router = useRouter();
  let t0;
  if ($[0] !== href || $[1] !== router) {
    t0 = () => {
      router.prefetch(href);
    };
    $[0] = href;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onTouchStart = t0;
  let t1;
  if ($[3] !== href || $[4] !== options || $[5] !== router) {
    t1 = e => {
      e.preventDefault();
      options?.onBeforeNavigate?.();
      startTransition(() => {
        router.push(href);
      });
    };
    $[3] = href;
    $[4] = options;
    $[5] = router;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const onClick = t1;
  let t2;
  if ($[7] !== href || $[8] !== onClick || $[9] !== onTouchStart) {
    t2 = {
      href,
      onTouchStart,
      onClick
    };
    $[7] = href;
    $[8] = onClick;
    $[9] = onTouchStart;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};